import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectLinkApi, selectLoadedPlatform, } from '../state/slices/slice-link-api';
/*
 * This hook is meant to only be used by our LinkAPI views,
 * it marks success, error and processing as loading.
 * Success and error are marked as loading because we show the loading
 * spinner while we navigate to a different screen (from Login or DDS jobs).
 * We use these to be able to manually handle these responses, to
 * either re-route or do other actions such as polling next, without
 * having to render anything else.
 */
var useIsLinkApiLoading = function () {
    var linkApiState = useSelector(selectLinkApi);
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var linkApiResponse = linkApiState.linkApiResponses[0];
    var loading = linkApiState.loading;
    var isLoading = useMemo(function () {
        return loading ||
            !loadedPlatform ||
            !linkApiResponse ||
            (linkApiResponse &&
                (linkApiResponse.responseType === 'success' ||
                    linkApiResponse.responseType === 'error' ||
                    linkApiResponse.responseType === 'processing'));
    }, [linkApiResponse, loading, loadedPlatform]);
    return isLoading;
};
export default useIsLinkApiLoading;
